<template>
    <div v-if="shlefInfo" class="login-box">
      <div class="login-box-user flex">
        <img src="../assets/images/newicon/man.png" class="login-box-user-headimg">
        <div class="login-box-user-info">
          <p class="login-box-user-info-name">{{shlefInfo.name}}，您好！</p>
          <p class="login-box-user-info-num">总投递数: <span> {{shlefInfo.positionStatistics.deliveredTotal}}</span></p>
          <img>
          <div class="flex login-box-user-info-deliver">
            <div class="flexColumn"><span>{{ shlefInfo.positionStatistics.deliveredDay }}</span>  今日投递 </div>
            <div class="flexColumn"><span>{{shlefInfo.positionStatistics.feedbackTotal}}</span>  面试邀请</div>
          </div>
        </div>

      </div>
      <div class="login-box-resume" @click="goMyresume">在线简历</div>
        
    </div>
    <div v-else class="main-box-info">
        <div class="main-box-info-login">
            <div class="main-box-info-login-boxs flexColumn">
               <p>IT内推圈 靠谱真需求</p>
               <p class="main-box-info-login-boxs-subtitle">首次验证通过即可注册IT内推圈</p>
               <div class="flex main-box-info-login-boxs-inputs itemsCenter">
                  <img src="../assets/images/newicon/phone.png" alt="">
                  <p class="">+86</p>
                  <el-input size="small" v-model="username" placeholder="请输入手机号" ></el-input>
              </div>
              
              <div class="flex main-box-info-login-boxs-inputs itemsCenter ">
                <img src="../assets/images/newicon/codes.png" alt="">
                  <el-input size="small" v-model="smscaptcha" placeholder="短信验证码" ></el-input>

                  <el-button
                        type="text"
                        @click="sendVcodeAction"
                        :loading="vcodeSending"
                      >
                        <i v-if="this.count > 0">{{ this.count }}s后重新发送</i>
                        <i v-else>{{
                          vcodeSending ? "正在获取验证码" : "获取验证码"
                        }}</i>
                      </el-button>
                  <!-- <span v-show="showCode" class="shrink" @click="getCode">发送验证码</span>
                  <span v-show="!showCode" class="shrink" >{{ count }}s后重新获取</span> -->
              </div>

              <!-- <div class="flex main-box-info-login-boxs-inputs itemsCenter">
                <img src="../assets/images/newicon/password.png" alt="">
                  <el-input size="small" v-model="password" placeholder="请输入图形验证码" ></el-input>
              </div> -->

              <div class="main-box-info-login-gologin" @click="sendLogin">登录/注册</div>
              <div style="width: 100%;" class="flex main-box-info-login-agree">
                <el-checkbox v-model="agreeCheck"></el-checkbox>
                <span>已阅读并同意IT内推圈
                  <a href="/index/userAgreement"
                  target="_blank"
                  @click="agreeCheck = true"> 《用户协议》</a>
                  <a href="/index/privacy"
                  target="_blank"
                  @click="agreeCheck = true">《隐私政策》</a>,允许IT内推圈统一管理本人账号信息
                </span>
              </div>
            </div>
        </div>
    </div>
</template>
  
  <script>
  import { getLoadings } from "../libs/vuex-loading/index";
  import { base64 } from "../libs/utilts";
  import manAvatar from "../assets/images/newicon/man.png";
  import womanAvatar from "../assets/images/newicon/woman.png";
  import { mapActions, mapState,mapGetters } from "vuex";
  export default {
    props: {
      types:{
        type:Number,
        default:null
      }
    },
    components: {
     
    },
    data(){
        return{
            username: "", //登陆手机号
            password: "", //登陆密码
            smscaptcha: "", //登陆验证码
            
            agreeCheck:false,
            showCode:true,
            count:0,
            timer: null,

        }
        
    },
    create(){
      console.log(shlefInfo,"个人信息")
    },
    computed: {
      ...mapState({
        shlefInfo: state => state.user.info, //个人信息
      }),
      ...getLoadings(loadings => ({
        vcodeSending: loadings.action("sendVcode")
      })),
    },
    methods:{
      ...mapGetters(["isLogin"]),
      ...mapActions(["login","checkMobile","getInitDate","sendVcode"]),
      
      //简历查看
      goMyresume() {
        if (!this.isLogin) {
          this.$router.push("/login");
        } else {
          this.$router.push("/myresume");
        }
      },
        //获取手机验证码
      async sendVcodeAction() {
        if(!this.username) this.$message.error("请先填写手机号");
        if (this.count > 0) return ;
        const mobile = this.username;
        const phoneEx = await this.checkMobile(mobile);
        if (!phoneEx.data) return this.$message.error("账号不存在");
        const { data, message } = await this.sendVcode({
          // captcha,
          // captchaHashing,
          mobile,
          smsTemplateType: "LOGIN"
        });
        if (data) {
          this.$message.success("验证码发送成功，请注意查收!");
          this.count = 60;
          this.timer = setInterval(() => {
            this.count--;
            if (this.count === 0) {
              clearInterval(this.timer);
            }
          }, 1000);
        } else {
          this.$message.error(message);
        }
      },
      destroyed() {
        clearInterval(this.timer);
      },
       //用户头像处理
       defaultAvatar() {
        return shlefInfo.gender=='男' ? manAvatar :shlefInfo.gender=='女'? womanAvatar:''
        return defaultAvatar;
      },
      // 登录
      async sendLogin() {
        if (!this.username) {
          return this.$message.error("请填写手机号码");
        }
        if (!this.password) {
          return this.$message.error("请填写密码");
        }
        if (!this.smscaptcha) {
          return this.$message.error("请填写验证码");
        }
        if (!this.agreeCheck) {
          return this.$message.error("请先同意用户协议");
        }
        
        const password = base64(`${this.username}:${this.password}`);
        const res = await this.login({
          username: this.username,
          password: password,
          smscaptcha:this.smscaptcha,
          userType: "SEEKER",
          grantType: "password"
        });
        if (res.code == 200) {
          window.localStorage.setItem("token", res.data.accessToken);
          this.getInitDate();
          this.$message({
            message: "登陆成功",
            type: "success"
          });
        } else {
          this.$message.error(res.message);
        }
      },
      gotoPrivacy(){
        this.agreeCheck=true;
        let url = this.$router.resolve({
          path:'/register/protocol/introduce'
        })
        window.open(url.href,'_blank')
      }

    },
     
     
  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  @yellowColor:#FF8A16;
  .login-box{
    padding: 20px 24px;
    width: 302px;
    background:  @whiteColor;
    box-shadow: 0px 6px 24px -4px rgba(0,0,0,0.1);
    border-radius: 6px;
    border: 1px solid #E8EDF1;
    margin-bottom: 24px;
    &-user{
      align-items: flex-start;
      img{
        width:56px ;
        margin-right: 8px;
      }
      &-info{
        &-name{
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          span{
            padding-left: 4px;
            font-size: 16px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
          }
        }
        &-num{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
        &-deliver{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          div{
            span{
              font-size: 28px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: @mianColor;
            }
            &:first-child{
              margin-right: 40px;
              span{
                color: #21BE57;
              }
            }
          }
        }
      }
    }
    &-resume{
      margin-top: 20px;
      width: 254px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:  @mianColor;
      box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
      border-radius: 6px;
      border: 1px solid @mianColor;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      cursor: pointer;
    }
  }
  .main-box-info-login{
        width: 302px;
        background: #FFFFFF;
        box-sizing: border-box;
        box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
        border-radius: 6px;
        padding: 10px;
        margin-bottom: 24px;
        &-boxs{
          background: linear-gradient(360deg, rgba(81,179,250,0) 0%, rgba(40, 124, 243, .2) 100%);
          border-radius: 4px 4px 0px 0px;
          padding: 28px 24px 0;
          p{
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 28px;
          }
          &-subtitle{
            font-family: PingFangSC-Regular, PingFang SC !important;
            font-size: 12px !important;
            font-weight: 400 !important;
          }
          &-inputs{
            width: 100%;
            background: @whiteColor;
            border-radius: 6px;
            border: 1px solid #D9D9D9;
            padding: 0 10px;
            box-sizing: border-box;
            margin: 8px 0;
            img{
              width: 16px;
              height: 16px;
            }
            p{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              padding-left: 4px;
            }
            span{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: @mianColor;
              cursor: pointer;
            }
            /deep/.el-input__inner{
              border: none !important;
            }
          }
        }
        &-gologin{
          width: 100%;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background:  @mianColor;
          box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @whiteColor;
          margin: 24px 0 16px;
          cursor: pointer;
          
        }
        &-agree{
          span{
            padding-left: 6px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.55);
            line-height: 18px;
            cursor: pointer;
          }
        }
  }
  .el-button--text{
    color: @mianColor;
  }
  </style>
  